const globalSettings = {
    apikey: "16803"
}

export default globalSettings